<template>
  <div class="card-header">
    <div class="card-header__left">
      <slot name="back" />
    </div>
    <div
      class="card-header__title"
      :class="{ 'card-header__title--centered': hasBackSlot }"
      :style="{ fontSize: fontSize + 'px' }"
    >
      {{ title }}
    </div>
    <div class="card-header__right">
      <slot name="extra" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    title: {
      type: String,
      default: 'Account'
    },
    fontSize: {
      type: Number,
      default: 36
    }
  },
  computed: {
    hasBackSlot() {
      return !!this.$slots.back
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  padding: 20px;
  position: relative;
}

.card-header__left {
  display: flex;
  align-items: center;
}

.card-header__right {
  display: flex;
  align-items: center;
}

.card-header__title {
  font-weight: 600;
  color: #091540;
  flex: 1;
  text-align: left;
  transition: text-align 0.2s;
}

.card-header__title--centered {
  text-align: center;
}
</style>
